/**
 * UI copy for a room's named live copies. The API resource is `/designs`
 * regardless of these strings — change this catalog (or swap it in an A/B)
 * without touching routes or the reducer.
 */
export const DESIGN_COPY = {
  singular: 'Design',
  plural: 'Designs',
  newAction: 'New design',
  defaultLabel: 'Design 1',
  copySuffix: (label: string) => `${label} copy`,
} as const;

export type DesignCopy = typeof DESIGN_COPY;

/** Filesystem-style uniquify: `Foo`, then `Foo 2`, `Foo 3`, … */
export function uniqueLabel(desired: string, existing: readonly string[]): string {
  const base = desired.trim() || DESIGN_COPY.defaultLabel;
  if (!existing.includes(base)) return base;
  let n = 2;
  while (existing.includes(`${base} ${n}`)) n += 1;
  return `${base} ${n}`;
}

/** `Design 1 copy`, then `Design 1 copy 2` if that name is taken. */
export function copyLabel(source: string, existing: readonly string[]): string {
  return uniqueLabel(DESIGN_COPY.copySuffix(source), existing);
}

/** Next unused `Design N` among `existing` labels. */
export function nextBlankLabel(existing: readonly string[]): string {
  let n = 1;
  let candidate = `${DESIGN_COPY.singular} ${n}`;
  while (existing.includes(candidate)) {
    n += 1;
    candidate = `${DESIGN_COPY.singular} ${n}`;
  }
  return candidate;
}
